import { PopupProps } from "../helper/interface";

const MessagePopup = ({ show, onClose }: PopupProps) => {
  if (!show) return null;

  return (
    <div className="message-popup-overlay">
      <div className="message-popup-box">
        <p>
          <b>This feature is on its way!</b><br />
          We’re putting the final touches on it.<br />
          Check back soon.
        </p>
        <button onClick={onClose} className="message-ok-btn">
          OK
        </button>
      </div>
    </div>
  );
};

export default MessagePopup;
